import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/Card';
import { MoneyDisplay } from '@/components/ui/MoneyDisplay';

type Props = {
  periodIn: string;
  periodOut: string;
  periodNet: string;
  periodDebtIncurred: string;
  periodDebtPaid: string;
  periodDebtNet: string;
};

export function CashbookPeriodCards({
  periodIn,
  periodOut,
  periodNet,
  periodDebtIncurred,
  periodDebtPaid,
  periodDebtNet
}: Props) {
  const { t } = useTranslation();

  const cards = [
    { label: t('cashbook.periodIn'), value: periodIn },
    { label: t('cashbook.periodOut'), value: periodOut },
    { label: t('cashbook.periodNet'), value: periodNet },
    { label: t('cashbook.debts.periodIncurred'), value: periodDebtIncurred },
    { label: t('cashbook.debts.periodPaid'), value: periodDebtPaid },
    { label: t('cashbook.debts.periodNet'), value: periodDebtNet }
  ];

  return (
    <div className="mt-4 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-6">
      {cards.map((c) => (
        <Card key={c.label} className="flex min-h-[4.5rem] flex-col p-2.5 sm:p-3">
          <p className="text-xs text-[var(--fv-text-muted)]">{c.label}</p>
          <p className="mt-1 text-base font-semibold tabular-nums sm:text-lg">
            <MoneyDisplay value={c.value} />
          </p>
        </Card>
      ))}
    </div>
  );
}
